

    class FAQManager {
        constructor() {
            this.tabButtons = document.querySelectorAll('.csft-tab-btn');
            this.categoryContents = document.querySelectorAll('.csft-faq-category-content');
            this.activeCategoryTitle = document.getElementById('csft-activeCategoryTitle');
            this.init();
        }

        init() {
            this.bindTabEvents();
            this.bindAccordionEvents();
        }

        bindTabEvents() {
            this.tabButtons.forEach(button => {
                button.addEventListener('click', (e) => {
                    const category = e.currentTarget.dataset.category;
                    const title = e.currentTarget.textContent;
                    this.switchTab(category, title);
                    this.updateActiveButton(e.currentTarget);
                });
            });
            //  Trigger first tab automatically
            if (this.tabButtons.length) {
                this.tabButtons[0].click();
            }

        }

        switchTab(categoryId, title) {
            this.categoryContents.forEach(content => content.classList.remove('active'));
            const selectedCategory = document.getElementById(categoryId);
            const faqtabsElBox = document.querySelector(".cs-faq-tabs");
            if (selectedCategory) {
                selectedCategory.classList.add('active');
                if (this.activeCategoryTitle) {
                    this.activeCategoryTitle.textContent = title;
                }
                this.closeAllAccordions(selectedCategory);
                // Smooth scroll so section top aligns with viewport top
                faqtabsElBox.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
                });

                
            }
        }

        updateActiveButton(activeBtn) {
            this.tabButtons.forEach(btn => btn.classList.remove('active'));
            activeBtn.classList.add('active');
        }

        bindAccordionEvents() {
            const faqContent = document.querySelector('.csft-faq-content');
            if (faqContent) {
                faqContent.addEventListener('click', (e) => {
                    const header = e.target.closest('.csft-accordion-header');
                    if (!header) return;
                    const accordionItem = header.parentElement;
                    this.toggleAccordion(accordionItem);
                });
            }
        }

        toggleAccordion(item) {
            const isOpen = item.classList.contains('open');
            const parentCategory = item.closest('.csft-faq-category-content');
            const currentlyOpen = parentCategory.querySelector('.csft-accordion-item.open');

            if (currentlyOpen && currentlyOpen !== item) {
                currentlyOpen.classList.remove('open');
                setTimeout(() => {
                    item.classList.add('open');
                }, 150);
            } else {
                if (isOpen) {
                    item.classList.remove('open');
                } else {
                    item.classList.add('open');
                }
            }
        }

        closeAllAccordions(container, excludeItem = null) {
            const items = container.querySelectorAll('.csft-accordion-item');
            items.forEach(item => {
                if (item !== excludeItem) {
                    item.classList.remove('open');
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        new FAQManager();
    });

